export const getDiscoverSectionStyles = (_, { palette = {} }) => ({
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sloganContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '760px',
    marginBottom: '48px',
    '& .create-now-button': {
      height: '48px',
      fontSize: '16px',
      padding: '12px 24px',
      backgroundColor: `${palette.black} !important`,
    },
  },
  'sloganContainer-m': {
    '& .create-now-button': {
      width: '100%',
    },
  },
  'sloganContainer-s': {
    marginBottom: '24px',
    maxWidth: '100%',
    '& .create-now-button': {
      width: '100%',
      fontSize: '24px',
    },
  },
  // Base styles for title component
  discoverTitle: {
    fontSize: '96px', // Desktop default
    fontWeight: 700,
    lineHeight: '104px',
    margin: '0px 48px 24px',
    textAlign: 'center',
    transition: 'font-size 0.3s ease', // Smooth transition for responsive changes
  },
  'discoverTitle-l': {
    fontSize: '72px',
    lineHeight: '84px',
    margin: '0px 36px 24px',
  },
  'discoverTitle-m': {
    fontSize: '48px',
    lineHeight: '56px',
    margin: '0px 24px 24px',
  },
  'discoverTitle-s': {
    fontSize: '32px',
    lineHeight: '35px',
    margin: '0px 0px 24px',
  },

  // Base styles for subtitle component
  discoverSubtitle: {
    fontSize: '40px', // Desktop default
    fontWeight: 600,
    lineHeight: '56px',
    textAlign: 'center',
    marginTop: '0px',
    marginBottom: '24px',
    transition: 'font-size 0.3s ease',
  },
  'discoverSubtitle-l': {
    fontSize: '36px',
    lineHeight: '48px',
  },
  'discoverSubtitle-m': {
    fontSize: '32px',
    lineHeight: '40px',
  },
  'discoverSubtitle-s': {
    fontSize: '24px',
    lineHeight: '28px',
  },

  // Base styles for description component
  discoverDescription: {
    fontSize: '24px', // Desktop default
    fontWeight: 400,
    lineHeight: '33px',
    textAlign: 'center',
    marginTop: '0px',
    marginBottom: '24px',
    transition: 'font-size 0.3s ease',
  },
  'discoverDescription-l': {
    fontSize: '22px',
    lineHeight: '30px',
  },
  'discoverDescription-m': {
    fontSize: '21px',
    lineHeight: '28px',
  },
  'discoverDescription-s': {
    fontSize: '20px',
    lineHeight: '25px',
  },
  inputsBoxContainer: {
    width: '100%',
    marginTop: '0px',
    marginBottom: '24px',
  },
  adPreviewPlaceholderContainer: {
    width: '98vw',
    overflow: 'hidden',
    margin: 0,
    padding: 0,
    display: 'flex',
    justifyContent: 'center',
  },
});
